<div class="auth-bootstrap" role="status" aria-live="polite" aria-busy="true">
  <div class="auth-bootstrap__spinner" aria-hidden="true"></div>
  <p class="auth-bootstrap__text">Loading…</p>
</div>
